import { Texture, TextureLoader } from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';

export const loadGltf = async (uri: string): Promise<GLTF> => {
  const loader = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath('https://rhym.s3.ap-south-1.amazonaws.com/draco/');
  dracoLoader.preload();

  loader.setDRACOLoader(dracoLoader);
  return new Promise((resolve, reject) => {
    loader.load(
      uri,
      gltf => resolve(gltf),
      undefined,
      error => reject(error)
    );
  });
};

export const loadFbx = async (uri: string) => {
  const loader = new FBXLoader();
  return new Promise((resolve, reject) => {
    loader.load(
      uri,
      obj => resolve(obj),
      undefined,
      error => reject(error)
    );
  });
};
export const loadImageTexture = async (uri: string): Promise<Texture> => {
  const loader = new TextureLoader();
  return new Promise((resolve, reject) => {
    loader.load(
      uri,
      texture => {
        // const material = new MeshBasicMaterial({
        //   map: texture,
        //   transparent: true,
        // });
        // const geometry = new PlaneGeometry(1, 1); // You can adjust the size
        // const plane = new Mesh(geometry, material);
        // plane.position.set(0, 0.5, 0);

        resolve(texture);
      },
      undefined,
      error => reject(error)
    );
  });
};
